<template>
    <div style="display: flex; flex-direction: row; gap: 0.666vmin">
        <div v-for="i in props.max" :style="'width: ' + (props.level / props.max) * 100 + '%;'" v-bind:key="i">
            <div :style="'background-color: ' + (i === Number(props.level) ? props.color : '#e0e0e0') + '; height: ' + props.height + 'vw; border-radius: 5px;'"></div>
            <div style="font-size: 1vw; font-weight: 500; margin-top: 0.2vw" :style="'color:' + (i === Number(props.level) ? props.color : '#8e8e8e') + '; text-align:' + (i === 1 ? 'left' : i === 3 ? 'right' : 'center')">{{ i }}레벨</div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';

// const chartdiv = ref(null);
const props = defineProps({
    level: {
        default: 1,
    },
    max: {
        default: 6,
    },
    height: {
        default: 2,
    },
    color: {
        default: '#77d87f',
    },
});

onMounted(() => {});
</script>

<style scoped lang="scss"></style>
